<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p.u-mb-ts {{item.desc}}
            AppLink(v-if="item.url" :to="item.url" :title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Brand management",
    "pageDesc":"Building your brand infrastructure by conducting brand research and creating your brand strategy, vision, promise and more.",
    "mantra":"Manage your brand |infrastructure.",
    "mantraDesc":"By laying the basics, we empower you to manage every brand signal, plan for your audience communication, and align your business goals with your branding efforts. ",
    "sec1":"Outline your brand strategy.",
    "sec1Items":{
      "1":{
        "title":"Brand Vision",
        "desc":"Outlining a statement inspired by your brand values and ethics that easy to connect and commit to. Whelp you come up with a vision that inspires your employees and represents your company in a creative manner"
      },
      "2":{
        "title":"Brand Personality",
        "desc":"To stand in the world of furious competition, you need to have a charismatic personality. When working on any brand, it’s essential to humanize it through a distinctive voice that expresses its essence. A tone that completes the verbal identity. And a writing style that closes the circle. "
      },
      "3":{
        "title":"Brand objectives",
        "desc":"Turing aspirations into reality by setting your brand clear targets both for the short and long term. Together, we create your mission based on basic assumptions then define the brand catalytic mechanisms."
      },
      "4":{
        "title":"Brand culture",
        "desc":"Auditing your organizational culture for better alignment with the brand strategy. Assessing where you stand by taking inputs from your teams the iterating based on the values you want to reach."
      },
      "5":{
        "title":"Brand activation",
        "desc":"Activating your brand both internally and externally to deliver your brand promise. Conducting brand resourcing with and enhancing your value delivery system based on operations and people 's behaviors."
      },
      "6":{
        "title":"Brand evaluation",
        "desc":"Setting the brand metrics internally and externally. Capitalizing on your insights to fine tone the brand and grow the brand equity and gain brand reputation. "
      }
    },
    "sec2":"Turning strategy into visuals.",
    "sec2Items":{
      "1":{
        "title":"Brand identity design",
        "desc":"Planning your visual styles based on the strategy created. Expressing your essence in a visual manner and communicating with your audience.",
        "url":"/services/brand-identity-design"
      },
      "2":{
        "title":"Logo development",
        "desc":"Whether logotype, pictorial mark or other, ensure that a memorable brand that stands the test of time",
        "url":"/services/logo-design"
      }
    },
    "cta":"Grow your brand <br> strategically"
  },
  "ar": {
    "pageTitle":"إدارة العلامة التجارية",
    "pageDesc":"نساعدك على إدارة علامتك التجارية من خلال إجراء الأبحاث وإنشاء الاستراتيجية وتحديد الرؤى والأهداف التي تجعلك مميزًا عن منافسيك.",
    "mantra":"إدارة العلامة التجارية |من أجل مظهر جذاب. ",
    "mantraDesc":"من خلال تحديد الأساسيات، سوف تتمكن من إدارة كل رسالة صادرة عن العلامة التجارية والتخطيط لكيفية التواصل مع جمهورك ومواءمة أهداف عملك مع جهود العلامة التجارية. ",
    "sec1":"خطط استراتيجية العلامة التجارية",
    "sec1Items":{
      "1":{
        "title":"رؤية العلامة التجارية",
        "desc":"حدد بيان قائم على  قيم وأخلاقيات العلامة التجارية التي يسهل التواصل من خلالها وكذلك الالتزام بها. نفكر معك فى الرؤية التي تناسب علامتك التجارية وتلهم موظفيك وتمثل شركتك بالصورة التي تتمناها."
      },
      "2":{
        "title":"شخصية العلامة التجارية",
        "desc":"للنجاح في عالم المنافسة الشرس، تحتاج إلى أن يكون لدى علامتك التجارية شخصية جذابة. عند العمل على أي علامة تجارية، من الضروري إضفاء الطابع الإنساني عليها من خلال صوت مميز يعبر عن جوهرها، ونغمة تكُمل الهوية اللفظية الخاصة بها وأسلوب كتابتها الفريد الذي يكمل شخصيتها."
      },
      "3":{
        "title":"أهداف العلامة التجارية",
        "desc":"نعمل على تحقيق تطلعاتك إلى واقع ملموس من خلال تحديد أهداف واضحة لعلامتك التجارية على المدى سواء  القصير أو الطويل. معًا، نقوم بإنشاء مهمة العلامة الأساسية استنادًا إلى الافتراضات، ثم نحدد الآليات التي تحفزها."
      },
      "4":{
        "title":"ثقافة العلامة التجارية",
        "desc":"نعمل على مراجعة ثقافتك التنظيمية لكي تتوافق مع استراتيجية العلامة التجارية. نقيم وضعك الحالي من خلال الحصول على المعلومات من فريقك ثم نقوم ببناء القيم التي تريد الوصول إليها."
      },
      "5":{
        "title":"تفعيل البراند",
        "desc":"نعمل على تنشيط علامتك التجارية داخليًا وخارجيًا لتحقيق الوعد الذي قطعته لعملائك، ثم نعمل على ملائمة موارد علامتك التجارية مع القيمة التي تريد تقديمها لعملائك وكذلك مع سلوكيات جمهورك المستهدف."
      },
      "6":{
        "title":"تقييم العلامة التجارية",
        "desc":"نضع مقاييس العلامة التجارية داخليًا وخارجيًا، من أجل الاستفادة بالرؤى والأفكار في دعم العلامات التجارية وتنمية سمعتها واكتساب المزيد من العملاء."
      }
    },
    "sec2":"حول استراتيجيك إلى صور",
    "sec2Items":{
      "1":{
        "title":"تصميم الهوية التجارية",
        "desc":"بعد تحديد الاستراتيجية نعمل على تحويل كل هذه الأساسيات إلى صور وبصريات تعبر عن جوهر العلامة التجارية وتساعد على توصيل الرسالة وتزيد من التواصل مع الجمهور.",
        "url":"/services/brand-identity-design"
      },
      "2":{
        "title":"تطوير الشعار",
        "desc":"سواء تخطط لإنشاء شعارًا أو علامة تصويرية (pictorial mark)...غيرها، تأكد أن العلامة التجارية التي لا تنسى هي التي تصمد أمام المنافسة والتغيرات التي تحدث.",
        "url":"/services/logo-design"
      }
    },
    "cta":"أسس علامتك التجارية <br> استراتيجيًا."
  }
}
</i18n>
